import styles from './OnboardingNotification.module.scss';
import React, { useEffect, useState } from 'react';
import { ExternalAuthProvider } from '@support/electron-external';
import { Alert } from '@components/Alert';
import { AlertType } from '@app/types';
import cn from 'classnames';

interface AlertDetails {
  text: string;
  type: AlertType;
}

export default function OnboardingNotificationArea() {
  const [activeAlert, setActiveAlert] = useState<AlertDetails | null>(null);

  useEffect(() => {
    if (window.app.isElectron && window.desktopIntegrations) {
      const handleConnectionSuccess = (provider: ExternalAuthProvider) => {
        setActiveAlert({
          text: `Successfully connected ${provider} account`,
          type: 'success',
        });
      };
      const handleConnectionError = (provider: ExternalAuthProvider) => {
        setActiveAlert({
          text: `Error connecting ${provider} account`,
          type: 'error',
        });
      };
      const unsub1 = window.desktopIntegrations.onConnection(handleConnectionSuccess);
      const unsub2 = window.desktopIntegrations.onConnectionError(handleConnectionError);
      return () => {
        unsub1();
        unsub2();
      };
    }
    return () => {};
  }, []);

  useEffect(() => {
    if (activeAlert) {
      const timeOut = setTimeout(() => {
        setActiveAlert(null);
      }, 3000);
      return () => {
        clearTimeout(timeOut);
      };
    }
    return () => {};
  }, [activeAlert]);

  return (
    <div className={cn(styles.wrapper, activeAlert && styles.active)}>
      {activeAlert && <Alert type={activeAlert.type}>{activeAlert.text}</Alert>}
    </div>
  );
}
